import { toast } from 'react-toastify';
import { uploadImage } from '../api/storageApi';
import * as api from '../api/visitImagesApi';
import * as types from '../constants/visitImagesConstants';

export const getVisitImagesActions = (vin, visitId) => async (dispatch) => {
  dispatch({ type: types.GET_VISIT_IMAGES_REQUEST });
  try {
    const { error, data } = await api.getVisitImages(vin, visitId);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.GET_VISIT_IMAGES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити фото візиту');
    dispatch({ type: types.GET_VISIT_IMAGES_FAILURE });
  }
};

export const createVisitImageAction = (vin, visitId, image) => async (dispatch) => {
  try {
    const { data: url, error: uploadError } = await uploadImage(image);
    if (uploadError) {
      throw new Error(uploadError);
    } else {
      const { error } = await api.createVisitImage(vin, visitId, {
        url: url,
      });
      if (error) {
        throw new Error(error);
      }
      toast.success('Фото візиту було успішно додано');
    }
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося додати фото візиту');
  }
};

export const deleteVisitImageAction = (vin, visitId, imageId) => async () => {
  try {
    const { error } = await api.deleteVisitImage(vin, visitId, imageId);
    if (error) {
      throw new Error(error);
    }
    toast.success('Фото візиту було успішно видалено');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося видалити фото візиту');
  }
};

export const clearSelectedVisitImageAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_SELECTED_VISIT_IMAGE,
  });
};

export const clearVisitImagesActions = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_VISIT_IMAGES,
  });
};

export const setSelectedVisitImageAction = (image) => async (dispatch) => {
  dispatch({
    type: types.SELECT_VISIT_IMAGE,
    payload: image,
  });
};
